import { render, staticRenderFns } from "./SlickItem.vue?vue&type=template&id=251166bb&scoped=true"
import script from "./SlickItem.vue?vue&type=script&lang=js"
export * from "./SlickItem.vue?vue&type=script&lang=js"
import style0 from "./SlickItem.vue?vue&type=style&index=0&id=251166bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251166bb",
  null
  
)

export default component.exports